module.exports = __webpack_public_path__ + "static/media/person-green.5c0ce955.svg";